import { Container } from 'unstated';

class PageConfigCacheContainer extends Container {
  state = {
    header: null,
    footer: null,
  };

  cachePageConfig({ header, footer }) {
    // Only update when not null
    this.setState(() => (header ? { header } : null));
    this.setState(() => (footer ? { footer } : null));
  }
}

export default PageConfigCacheContainer;
